import { createContext } from "react";

export interface AuthContextValue {
  logout(): void;
}

export const AuthContext = createContext<AuthContextValue>({ logout: () => { /* empty */ } });
